<template>
  <div class="">
    <router-link
      :to="{
        name: 'regionDashboard',
        query: {
          regionId: data.id,
          companyId: this.$route.query.companyId
            ? this.$route.query.companyId
            : data.companyId,
        },
      }"
      style="text-decoration: none; color: rgb(75, 44, 114); width: auto"
      class="btn details_btn"
      :title="$t('text.clickButtons.viewDashboard')"
      v-if="data.branches > 0"
    >
      {{ $t("text.clickButtons.view") }}
      <i class="fa fa-eye primary-color"> </i>
    </router-link>

    <button
      style="
        text-decoration: none;
        color: rgb(75, 44, 114);
        width: auto;
        cursor: not-allowed;
      "
      type="button"
      class="btn details_btn"
      :title="$t('text.clickButtons.mapBranchesToViewDashboard')"
      v-else
    >
      {{ $t("text.clickButtons.view") }}
      <i class="fa fa-eye primary-color"> </i>
    </button>

    <router-link
      :to="{
        name: 'our_branches',
        query: { regionId: data.id, companyId: $route.query.companyId },
      }"
      style="text-decoration: none; color: rgb(75, 44, 114); width: auto"
      class="btn details_btn"
      :title="$t('text.clickButtons.viewBranches')"
      v-if="data.branches > 0"
    >
      {{ $t("text.clickButtons.branches") }} {{ data.branches }}
    </router-link>

    <button
      style="
        text-decoration: none;
        color: rgb(75, 44, 114);
        width: auto;
        cursor: not-allowed;
      "
      class="btn details_btn"
      :title="$t('text.clickButtons.mapBranchesToViewList')"
      v-else
    >
      {{ $t("text.clickButtons.branches") }} {{ data.branches }}
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
    };
  },
  mounted() {},
};
</script>
